export const FontOptions = [
	'Almendra-Bold',
	'Almendra-BoldItalic',
	'AnonymousPro-Bold',
	'AnonymousPro-BoldItalic',
	'Anton-Regular',
	'Antonio-Bold',
	'ArchivoNarrow-Bold',
	'ArchivoNarrow-BoldItalic',
	'ArchivoNarrow-Italic',
	'ArchivoNarrow-Regular',
	'Arimo-Bold',
	'Arimo-BoldItalic',
	'Arimo-Italic',
	'Arimo-Regular',
	'Asap-Bold',
	'Asap-BoldItalic',
	'Bitter-Bold',
	'Bitter-BoldItalic',
	'Boogaloo-Regular',
	'BreeSerif-Regular',
	'Cabin-Bold',
	'Cabin-BoldItalic',
	'Catamaran-Bold',
	'Catamaran-Regular',
	'CevicheOne-Regular',
	'Chewy-Regular',
	'Creepster-Regular',
	'CrimsonText-BoldItalic',
	'DeliusUnicase-Bold',
	'Dosis-Bold',
	'Exo-Bold',
	'Exo-BoldItalic',
	'Exo2-Bold',
	'Exo2-BoldItalic',
	'Exo2-Italic',
	'Exo2-Regular',
	'FiraSans-BoldItalic',
	'FrancoisOne-Regular',
	'FredokaOne-Regular',
	'Hind-Bold',
	'Hind-Regular',
	'Inconsolata-Bold',
	'Inconsolata-Regular',
	'JosefinSans-Bold',
	'JosefinSans-BoldItalic',
	'JosefinSans-Regular',
	'JosefinSans-SemiBold',
	'Karla-Bold',
	'Lato-Bold',
	'Lato-BoldItalic',
	'Lemon-Regular',
	'Lora-BoldItalic',
	'Merriweather-Regular',
	'MerriweatherSans-Bold',
	'MerriweatherSans-BoldItalic',
	'MerriweatherSans-Italic',
	'MerriweatherSans-Regular',
	'Montserrat-Bold',
	'Montserrat-BoldItalic',
	'Mulish-Black',
	'Mulish-BlackItalic',
	'Mulish-ExtraBold',
	'Mulish-ExtraBoldItalic',
	'Mulish-SemiBold',
	'Mulish-SemiBoldItalic',
	'NotoSans-Bold',
	'NotoSans-BoldItalic',
	'NotoSerif-Bold',
	'Nunito-Bold',
	'Nunito-BoldItalic',
	'OpenSans-Bold',
	'OpenSans-BoldItalic',
	'OpenSans-ExtraBold',
	'OpenSans-ExtraBoldItalic',
	'OpenSans-SemiBold',
	'OpenSans-SemiBoldItalic',
	'OpenSansCondensed-Bold',
	'OpenSansHebrew-Bold',
	'OpenSansHebrew-BoldItalic',
	'OpenSansHebrew-ExtraBold',
	'OpenSansHebrew-ExtraBoldItalic',
	'OpenSansHebrew-Italic',
	'OpenSansHebrew-Light',
	'OpenSansHebrew-LightItalic',
	'OpenSansHebrew-Regular',
	'OpenSansHebrewCondensed-Bold',
	'OpenSansHebrewCondensed-BoldItalic',
	'OpenSansHebrewCondensed-ExtraBold',
	'OpenSansHebrewCondensed-ExtraBoldItalic',
	'OpenSansHebrewCondensed-Italic',
	'OpenSansHebrewCondensed-Light',
	'OpenSansHebrewCondensed-LightItalic',
	'OpenSansHebrewCondensed-Regular',
	'Orbitron-Black',
	'Orbitron-Bold',
	'Orbitron-Medium',
	'Orbitron-Regular',
	'Oswald-Bold',
	'Oswald-Regular',
	'Oxygen-Bold',
	'Oxygen-Regular',
	'Poppins-Black',
	'Poppins-BlackItalic',
	'Poppins-Bold',
	'Poppins-BoldItalic',
	'Poppins-ExtraBold',
	'Poppins-ExtraBoldItalic',
	'Poppins-Italic',
	'Poppins-Medium',
	'Poppins-MediumItalic',
	'Poppins-Regular',
	'Poppins-SemiBold',
	'Poppins-SemiBoldItalic',
	'Prociono-Regular',
	'Questrial-Regular',
	'Quicksand-Bold',
	'Quicksand-Regular',
	'Raleway-Bold',
	'Raleway-Regular',
	'RaviPrakash-Regular',
	'RobotoMono-Bold',
	'RobotoMono-BoldItalic',
	'RobotoMono-Italic',
	'RobotoMono-Regular',
	'RussoOne-Regular',
	'Shrikhand-Regular',
	'Signika-Bold',
	'Signika-Regular',
	'SixCaps',
	'SourceSansPro-Bold',
	'SourceSansPro-BoldItalic',
	'SourceSansPro-Italic',
	'SourceSansPro-Regular',
	'Taviraj-Bold',
	'Taviraj-BoldItalic',
	'Taviraj-Italic',
	'Taviraj-Regular',
	'TitilliumWeb-Bold',
	'TitilliumWeb-BoldItalic',
	'TitilliumWeb-Italic',
	'TitilliumWeb-Regular',
	'Ubuntu-Bold',
	'Ubuntu-BoldItalic',
	'Ubuntu-Italic',
	'Ubuntu-Medium',
	'Ubuntu-MediumItalic',
	'Ubuntu-Regular',
	'UbuntuCondensed-Regular',
	'UbuntuMono-Bold',
	'UbuntuMono-BoldItalic',
	'UbuntuMono-Italic',
	'UbuntuMono-Regular',
	'VarelaRound-Regular',
	'WorkSans-Bold',
	'WorkSans-BoldItalic',
	'WorkSans-Regular',
	'YanoneKaffeesatz-Bold',
	'YanoneKaffeesatz-Regular',
];
